import { render, staticRenderFns } from "./AddOrganizationPointOfContactModal.vue?vue&type=template&id=c21d0f9a&"
import script from "./AddOrganizationPointOfContactModal.vue?vue&type=script&lang=ts&"
export * from "./AddOrganizationPointOfContactModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports